import { createAction } from 'redux-actions';
import { push } from 'react-router-redux';
import { openGlobalModal, closeGlobalModal } from 'actions/modal';
import { logout } from 'actions/auth';

import { getCookie } from 'util/cookie';
import { wrapFetch, wrapFetchAuth, wrapFetchFormData } from './endpoint';
import { toggleLoading } from './global';
// import { openGlobalModal } from './modal';

export const getMembers = createAction('GET_MEMBERS', () =>
	fetch('http://lab.25sprout.com/avatar/apo/25sproutMember.php', {
		method: 'GET',
	}).then(res => res.json(), () => ({ staffs: '' })));

export const cleanMembers = createAction('CLEAN_MEMBERS');

export const updateMemberData = createAction('UPDATE_MEMBER_DATA', (status, message, data) => async dispatch => {
	if (status === 200) {
		const cookieToken = getCookie('olympus-token');
		if (cookieToken === '') {
			dispatch(logout());
		} else {
			return {
				id: data.id,
				type: data.type,
				unlockTime: data.unlock_time,
				avatar: data.avatar,
				nickname: data.nickname,
				name: data.name,
				gender: data.gender,
				birthday: data.birth,
				identityType: data.identity_type,
				identity: data.identity,
				city: data.city,
				district: data.district,
				zipCode: data.zip_code,
				address: data.address,
				mobile: data.mobile,
				email: data.email,
				googleBind: data.google_id,
				facebookBind: data.fb_id,
				mobileVerify: data.mobile_verify,
				emailVerify: data.email_verify,
				sync: data.data_sync,
				credit: data.credit,
			};
		}
		return {};
	} else if (status === 401 && (message === 'Access token expired' || message === 'Access token has been revoked')) {
		dispatch(logout());
	}

	return {};
});

export const getMemberData = createAction('GET_MEMBER_DATA', () => async (dispatch, getState) => {
	const { auth: { token: { accessToken } } } = getState();
	if (accessToken === '') {
		return null;
	}
	dispatch(toggleLoading(true));
	const { status, message, data } = await wrapFetchAuth('api/web/user/me', {
		method: 'GET',
		cache: 'no-store',
	});
	dispatch(toggleLoading(false));
	dispatch(updateMemberData(status, message, data));

	return { data: {}, message };
});

export const sendEmailVerify = createAction('SEND_EMAIL_VERIFY', email => async dispatch => {
	dispatch(toggleLoading(true));
	const result = await wrapFetchAuth('api/web/user/sendEmailVerify', {
		method: 'POST',
		body: JSON.stringify({ email }),
	});
	dispatch(toggleLoading(false));

	if (result.status === 200 || result.status === 201) {
		dispatch(openGlobalModal('emailVerificationSend'));
		dispatch(getMemberData());
	} else if (result.status === 400 && result.message === 'duplicate email') {
		dispatch(openGlobalModal('emailVerifyDuplicate'));
	}
});

export const sendMobileVerify = createAction('SEND_MOBILE_VERIFY', mobile => async dispatch => {
	dispatch(toggleLoading(true));
	const result = await wrapFetchAuth('api/web/user/sendMobileVerify', {
		method: 'POST',
		body: JSON.stringify({ mobile }),
	});

	dispatch(toggleLoading(false));

	if (result.status === 200 || result.status === 201) {
		dispatch(getMemberData());
		dispatch(openGlobalModal('codeVerificationSend'));
		return {
			mobileVerifyFail: false,
		};
	} else if (result.status === 401 && result.message === 'less than a minute') {
		dispatch(openGlobalModal('codeVerifyMinute'));
	} else if (result.status === 400 && result.message === 'duplicate mobile') {
		dispatch(openGlobalModal('codeVerifyDuplicate'));
	}
	return {};
});

export const verifyEmailCode = createAction('VERIFY_EMAIL_CODE', emailCode => async dispatch => {
	const result = await wrapFetch('api/web/auth/emailVerify', {
		method: 'POST',
		body: JSON.stringify({ email_code: emailCode }),
	});

	if (result.status === 200) {
		dispatch(push('/member'));
	} else {
		dispatch(openGlobalModal('verifyEmailFailed'));
	}
});

export const verifyMobileCode = createAction('VERIFY_MOBILE_CODE', mobileCode => async dispatch => {
	dispatch(toggleLoading(true));
	const result = await wrapFetchAuth('api/web/user/mobileVerify', {
		method: 'POST',
		body: JSON.stringify({ mobile_code: mobileCode }),
	});
	dispatch(toggleLoading(false));
	if (result.status === 200) {
		dispatch(getMemberData());
		dispatch(closeGlobalModal('codeVerificationSend'));
		dispatch(openGlobalModal('codeVerifySuccess'));
	} else {
		return {
			mobileVerifyFail: true,
		};
	}
	return {};
});

export const saveMemberData = createAction('SAVE_MEMBER_DATA', (name, nickname, gender, birthday, identity, type, city, district, zipCode, address) => async dispatch => {
	dispatch(toggleLoading(true));
	const result = await wrapFetchAuth('api/web/user/me', {
		method: 'POST',
		body: JSON.stringify({
			name,
			nickname,
			gender,
			birth: birthday,
			identity,
			identity_type: type,
			city,
			district,
			zip_code: zipCode,
			address,
		}),
	});
	dispatch(toggleLoading(false));
	if (result.status === 200) {
		dispatch(openGlobalModal('memberSaveSuccess'));
		dispatch(getMemberData());
	}
});

export const bindFacebook = createAction('BIND_FACEBOOK', token => async dispatch => {
	const result = await wrapFetchAuth('api/web/user/bind/facebook', {
		method: 'POST',
		body: JSON.stringify({ service: 'facebook', token }),
	});
	if (result.status === 200) {
		dispatch(push('/member'));
		dispatch(getMemberData());
	}
});

export const bindGoogle = createAction('BIND_GOOGLE', token => async dispatch => {
	const result = await wrapFetchAuth('api/web/user/bind/google', {
		method: 'POST',
		body: JSON.stringify({ service: 'google', token }),
	});
	if (result.status === 200) {
		dispatch(push('/member'));
		dispatch(getMemberData());
	}
});

export const bindRemove = createAction('BIND_REMOVE', type => async dispatch => {
	dispatch(toggleLoading(true));
	const result = await wrapFetchAuth('api/web/user/removeSocialite', {
		method: 'POST',
		body: JSON.stringify({ type }),
	});
	dispatch(toggleLoading(false));
	if (result.status === 200) {
		dispatch(getMemberData());
	}
});

export const uploadUserPhoto = createAction('UPLOAD_USER_PHOTO', file => async dispatch => {
	const photoData = new FormData();

	photoData.append('avatar', file, 'user');

	dispatch(toggleLoading(true));
	const { status } = await wrapFetchFormData('api/web/user/me', {
		method: 'POST',
		body: photoData,
	});
	dispatch(toggleLoading(false));

	if (status === 200 || status === 201) {
		dispatch(getMemberData());
	}
});

export const checkIdentity = createAction('CHECK_IDENTITY', identity => async dispatch => {
	const result = await wrapFetch('api/web/user/checkIdentity', {
		method: 'POST',
		body: JSON.stringify({ identity }),
	});
	if (result.status === 200 || identity === '') {
		return {
			identityDuplicate: false,
		};
	} else if (result.status !== 200) {
		dispatch(openGlobalModal('memberIdentityDuplicate'));
		if (identity === '') {
			return {
				identityDuplicate: false,
			};
		} else if (identity !== '') {
			return {
				identityDuplicate: true,
			};
		}
	}
	return {};
});

export const checkMemberData = createAction('CHECK_MEMBER_DATA', () => async dispatch => {
	const { status, message, data } = await wrapFetchAuth('api/web/user/me', {
		method: 'GET',
		cache: 'no-store',
	});
	if (status === 401 && (message === 'Access token expired' || message === 'Access token has been revoked')) {
		dispatch(logout());
	}
	if (data.name === null || data.name === '') {
		dispatch(openGlobalModal('memberInfoEmailMobileNotyet'));
		dispatch(openGlobalModal('memberInfoNotyet'));
	}
	if (data.gender === null || data.gender === '') {
		dispatch(openGlobalModal('memberInfoEmailMobileNotyet'));
		dispatch(openGlobalModal('memberInfoNotyet'));
	}
	if (data.birthday === null || data.birthday === '') {
		dispatch(openGlobalModal('memberInfoEmailMobileNotyet'));
		dispatch(openGlobalModal('memberInfoNotyet'));
	}
	if (data.identity === null || data.identity === '') {
		dispatch(openGlobalModal('memberInfoEmailMobileNotyet'));
		dispatch(openGlobalModal('memberInfoNotyet'));
	}
	if (data.city === null || data.city === '') {
		dispatch(openGlobalModal('memberInfoEmailMobileNotyet'));
		dispatch(openGlobalModal('memberInfoNotyet'));
	}
	if (data.district === null || data.district === '') {
		dispatch(openGlobalModal('memberInfoEmailMobileNotyet'));
		dispatch(openGlobalModal('memberInfoNotyet'));
	}
	if (data.zipCode === null || data.zipCode === '') {
		dispatch(openGlobalModal('memberInfoEmailMobileNotyet'));
		dispatch(openGlobalModal('memberInfoNotyet'));
	}
	if (data.address === null || data.address === '') {
		dispatch(openGlobalModal('memberInfoEmailMobileNotyet'));
		dispatch(openGlobalModal('memberInfoNotyet'));
	}
	if (data.emailVerify === 0 || data.mobileVerify === 0) {
		dispatch(openGlobalModal('memberInfoEmailMobileNotyet'));
		dispatch(openGlobalModal('memberInfoNotyet'));
	}
});

export const emptyError = createAction('EMPTY_ERROR', empty => ({ empty }));
export const changeReducerIdentity = createAction('CHANGE_IDENTITY', identityDuplicate => ({ identityDuplicate }));



// WEBPACK FOOTER //
// ./src/actions/member.js